<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items-per-page="5"
            :items="deserts"
            >
            <template v-if="canEdit" v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>เพิ่มรายการงานนอก</v-toolbar-title>
                </v-toolbar>
                <v-divider
                    class="mx-4"
                    inset
                    ></v-divider>
                <v-form ref="formDetail" v-model="validDetail" lazy-validation>
                    <v-row class="ml-2">
                        <v-col>
                            <v-text-field  outlined placeholder=" " :rules="[rules.required]" label="รายการ" v-model="editedItem.itemName"></v-text-field>
                        </v-col>
                        <v-col cols="2"><v-text-field outlined placeholder=" " :rules="[rules.requiredNumber]" label="จำนวน" maxlength="4" v-model="editedItem.qty"></v-text-field></v-col>
                        <v-col cols="2"><v-text-field  outlined placeholder=" " :rules="[rules.requiredNumber]" label="ราคา/หน่วย" v-model="editedItem.unitPrice"></v-text-field></v-col>
                        <v-col cols="2" md="3">
                            <v-btn class="ma-2" color="primary" @click="saveDetail">เพิ่ม</v-btn>
                            <v-btn class="ma-2" color="primary" @click="closeDialog"> ล้าง</v-btn>
                        </v-col>
                    </v-row>
                </v-form> 
            </template>
            <template v-if="canEdit" v-slot:item.action="{ item }">
                    <v-icon
                        small
                        @click="deleteItem(item)"
                    >
                        delete
                    </v-icon>
                </template>
        </v-data-table>
    </v-container>
</template>

<script>
import rules from '@/assets/js/rules.js'
import numeral from 'numeral'

export default {
    name: 'BpeParts',
    props: ["branchCode", "modelCode", "currentItems", "canEdit"],
    computed: {
        deserts() {
            return this.currentItems ? this.currentItems : this.items;
        }
    },
    watch: {
        items: {
            handler(data){
                this.$emit("syncBpeExternal", data);
            },
            deep: true
        },
        currentItems(val) {
            if (val) this.items = val;
        }
    },
    data: () => ({
        headers: [
            {text: 'No.', value: 'no'},
            {text: 'รายการงานนอก', value: 'itemName'},
            {text: 'จำนวน', value: 'qty'},
            {text: 'ราคา/หน่วย', value: 'unitPriceDisplay'},
            {text: 'ยอดรวม', value: 'totalDisplay'},
            {text: 'รวมสุทธิ', value: 'grandTotalDisplay'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        rules: rules,
        items: [],
        editedItem: {
            no: 0,
            itemName: '',
            qty: 1,
            unitPrice: 1,
            discountPrice: 0,
            total: 0,
            grandTotal: 0,
            dirty: false
        },
        defaultItem: {
            no: 0,
            itemName: '',
            qty: 1,
            unitPrice: 1,
            discountPrice: 0,
            total: 0,
            grandTotal: 0,
            dirty: false
        },
        dialog: false,
        validDetail: false
    }),
    methods: {
        calulateDiscount(obj) {
            obj.total = obj.qty * obj.unitPrice;
            obj.grandTotal = obj.total;
            this.setDisplay(obj);
        },
        setDisplay(obj) {
            obj.totalDisplay = numeral(obj.total).format('0,0.00');
            obj.grandTotalDisplay = numeral(obj.grandTotal).format('0,0.00');
            obj.unitPriceDisplay = numeral(obj.unitPrice).format('0,0.00');
        },
        saveDetail() {
            if (!this.$refs.formDetail.validate()) {
                return;
            }
            this.editedItem.no = this.items.length + 1;
            this.editedItem.dirty = true;
            this.calulateDiscount(this.editedItem);
            this.items.push(this.editedItem);
            this.closeDialog();
        },
        closeDialog() {
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
            });
        },
        deleteItem (item) {
            if (!confirm("คุณต้องการลบข้อมูลใช่หรือไม่ ?")) {
                return;
            }
            let index = this.items.indexOf(item);
            this.items.splice(index, 1);
        },
        clearData() {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.items = [];
        }
    }
}
</script>